import "./Hero.css";
import heroBg from "../../../assets/images/homepage/hero-bg.png";
import { Link } from "react-router-dom";
const Hero = () => {
  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>
            AI, Strategy, and Growth <br />
            Advisory for Forward- <br />
            Looking Businesses
          </h1>

          <p>
            Karma & Delta LLC helps organizations use artificial intelligence,
            marketing intelligence, and strategic advisory to solve real
            business problems, improve decision-making, and build scalable
            growth.
          </p>

          <div className="hero-buttons">

            <Link to="/contact" className="primary-btn">
              Talk to Us
            </Link>

            <Link to="/services" className="secondary-btn">
              Explore Services
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;